import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Check, ArrowLeft, Play, Sparkles } from 'lucide-react';
import './GoalSettingsModal.css';

export default function GoalReachedDialog({ goals, language, onContinue, onChoose }) {
  const dialog=useRef(null), reduce=useReducedMotion(), ar=language==='ar', open=goals.length>0;
  useEffect(()=>{
    if(!open)return undefined;
    const previous=document.activeElement,overflow=document.body.style.overflow;
    document.body.style.overflow='hidden';dialog.current?.focus();
    return()=>{document.body.style.overflow=overflow;previous?.focus?.();};
  },[open]);
  const trap=event=>{
    if(event.key==='Escape'){event.preventDefault();event.stopPropagation();}
    if(event.key!=='Tab')return;
    const buttons=[...dialog.current.querySelectorAll('button')],first=buttons[0],last=buttons[buttons.length-1];
    if(event.shiftKey&&(document.activeElement===first||document.activeElement===dialog.current)){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  };
  return <AnimatePresence>{open&&<motion.div className="goal-modal-overlay goal-reached-overlay" dir={ar?'rtl':'ltr'}
    initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} transition={{duration:reduce?0:.18}} onClick={event=>event.stopPropagation()}>
    <motion.section className="goal-modal goal-reached-dialog" role="alertdialog" aria-modal="true" aria-labelledby="goal-reached-title" aria-describedby="goal-reached-description"
      ref={dialog} tabIndex={-1} onKeyDown={trap} initial={{y:reduce?0:20}} animate={{y:0}}>
      <div className="goal-reached-medal"><Check size={34}/><Sparkles size={18}/></div>
      <p className="goal-reached-eyebrow">{ar?'تقبّل الله منك':'A moment worth celebrating'}</p>
      <h3 id="goal-reached-title">{ar?'أتممت هدفك!':'Goal complete!'}</h3>
      {goals.map(goal=><div className="goal-reached-summary" key={goal.key}><span>{goal.scope==='dhikr'?goal.dhikr:(ar?'الهدف اليومي العام':'Overall daily goal')}</span><strong dir="ltr">{goal.count.toLocaleString(language)} / {goal.goal.toLocaleString(language)}</strong></div>)}
      <p id="goal-reached-description">{ar?'أوقفنا العدّ هنا. اختر ذكراً آخر، أو تابع هذا الذكر باختيارك.':'Counting is paused. Choose another dhikr, or choose to continue this one.'}</p>
      <button className="goal-modal-btn goal-modal-save" onClick={onChoose}><ArrowLeft size={18}/>{ar?'اختيار ذكر آخر':'Choose another dhikr'}</button>
      <button className="goal-modal-btn goal-modal-cancel" onClick={onContinue}><Play size={17}/>{ar?'الاستمرار في هذا الذكر':'Continue this dhikr'}</button>
    </motion.section>
  </motion.div>}</AnimatePresence>;
}
